<template>
  <div>
    <el-row :gutter="20">
      <div style="height:100px"></div>
      <el-col :span="24">
        <div class="header">
          <Auth />
        </div>
      </el-col>
      <el-col :span="24">
        <div>
          <h1 class="teste">Termos de Uso</h1>
        </div>
      </el-col>
    </el-row>
    <el-container width="100vw" class="container">
      <el-container width="70%">
        <p>
          {{ termos.data }}
        </p>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      termos: '',
    };
  },
  async created() {
    await this.loadTermos();
    console.log(this.users);
  },
  methods: {
    async loadTermos() {
      this.termos = await axios.get(
        'https://baconipsum.com/api/?type=meat-and-filler&paras=20&format=text'
      );
      console.log(this.termos);
      return this.termos;
    },
  },
};
</script>

<style>
.teste {
  margin-top: 30px;
  text-align: center;
}
.container {
  justify-content: center;
  margin: auto;
}
</style>
